import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchMembersCountByPartnerGroup = async (
  groupId: number,
  forceFetch: boolean = true
): Promise<number> => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.JBPCountMembersInGroup,
    'fetchMembersCountByPartnerGroup'
  )
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'GroupId',
        operator: Operator.EQUAL,
        value: groupId,
      },
    ],
  })

  const res = await crud.fetch({ force: forceFetch })
  if (res.items.length) {
    return res.items[0].MembersCount
  }
  return 0
}
